import { LapCounter } from '@cds/scoreboards/v1/shared';
import { EventModel, EventScoreboard, LeaderboardGameScore } from '@frontend/sports/betting-offer/feature/model';

import { MyBetsEventModel } from '../../my-bets/models/my-bets-event.model';
import { IEventTimeViewModel } from './scoreboard.viewmodel';
import { ScoreboardTournamentGameViewModel } from './tournament-scoreboard.viewmodel';

export class ScoreboardLeaderboardGameViewModel extends ScoreboardTournamentGameViewModel {
    constructor() {
        super();
        this.eventName = '';
        this.leagueName = '';
        this.players = [];
    }

    override eventName: string;
    leagueName: string;
    players: string[];
    override lapCounter: LapCounter;
    override weather: number | null;

    protected override __fillFromEvent(event: EventModel | MyBetsEventModel): void {
        super.__fillFromEvent(event);

        this.leagueName = event.league.name;
        const score = event.scoreboard.getScore<LeaderboardGameScore>()!;

        this.players = score.participants.slice(0, 3);
        this.lapCounter = { current: score.current, final: score.final, visible: !score.preRace };
        this.weather = score.preRace ? null : score.weather;
    }

    override getEventTimeViewModel(): IEventTimeViewModel {
        return super.getEventTimeViewModel();
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);

        const score = scoreboard.getScore<LeaderboardGameScore>();
        if (!score) {
            return;
        }

        this.players = score.participants.slice(0, 3);
        this.lapCounter = { current: score.current, final: score.final, visible: !score.preRace };
        this.weather = score.preRace ? null : score.weather;
    }
}
